import { useEffect, useState } from "react";
import { fallbackSession, sessionFromApi } from "../lib/session";

export function useSession() {
  const [session, setSession] = useState(fallbackSession);

  useEffect(() => {
    let isMounted = true;

    fetch("/api/me", {
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          return fallbackSession;
        }

        const data: unknown = await response.json();
        return sessionFromApi(data);
      })
      .then((nextSession) => {
        if (isMounted) {
          setSession(nextSession);
        }
      })
      .catch(() => {
        if (isMounted) {
          setSession(fallbackSession);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return session;
}
